import { kololinks } from './kololinks.reducers';

export default {
  kololinks
}